const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");

let { Component } = blop;


class FetchComponent extends Component {

  render() {
    const __1c = []; const __1a = {};
      if (this.list) {
        const __2c = []; const __2a = {};
          let __4 = this.list; let __5 = Object.keys(__4); let _i__3; for(let __6=0; __6 < __5.length; __6++) { _i__3 = __5[__6]; let item = __4[_i__3];
            const __7c = []; const __7a = {}; const __8 = item.name; Array.isArray(__8) ? __7c.push(...__8) : __7c.push(__8); const __7 = blop.h('li', __7a, __7c); __2c.push(__7);
          };
         const __2 = blop.h('ul', __2a, __2c); __1c.push(__2);
      }
     const __1 = blop.h('div', __1a, __1c); return __1;
  }


  async fetchData() {let signal, response;
    this.controller ? this.controller.abort() : undefined;
    this.controller = new AbortController();
    signal = this.controller.signal;
    response = await fetch(this.attributes.url, ({ signal }));
    this.list = (await response.json()).results;
    this.refresh();
  }


  onMount() {
    this.fetchData();
    this.onChange('url', () =>this.fetchData());
  }


  onUnmount() {
    this.controller ? this.controller.abort() : undefined;
  }

 }

class FetchPage extends Component {

  constructor() {
    super(...arguments);
    this.url = 'https://swapi.py4e.com/api/people/';
  }


  change(url) {
    this.url = url;
    this.refresh();
  }


  render() {let __13, __15;
    const __9c = []; const __9a = {};
      const __10c = []; const __10a = {}; const __11 = 'Using onMount to fetch data, and onChange to react to attribute changes'; Array.isArray(__11) ? __10c.push(...__11) : __10c.push(__11); const __10 = blop.h('p', __10a, __10c); __9c.push(__10);
      const __12c = []; const __12a = {}; __12a['on'] = ({ click: () =>this.change('https://swapi.py4e.com/api/people/') });
        __13 = 'People'; Array.isArray(__13) ? __12c.push(...__13) : __12c.push(__13); ;
       const __12 = blop.h('button', __12a, __12c); __9c.push(__12);
      const __14c = []; const __14a = {}; __14a['on'] = ({ click: () =>this.change('https://swapi.py4e.com/api/vehicles/') });
        __15 = 'Vehicle'; Array.isArray(__15) ? __14c.push(...__15) : __14c.push(__15); ;
       const __14 = blop.h('button', __14a, __14c); __9c.push(__14);
      const __16c = []; const __16a = {}; const __16 = blop.h('hr', __16a, __16c); __9c.push(__16);
      const __17c = []; const __17a = {}; __17a['url'] = this.url; const __17 = blop.c(FetchComponent, __17a, __17c, '__17'); __9c.push(__17);
     const __9 = blop.h('div', __9a, __9c); return __9;
  }


 }

module.exports = { Component, FetchComponent, FetchPage };
